// extracted by mini-css-extract-plugin
export var cardContainer = "_r9-0";
export var cardHeader = "_r9-2";
export var collapsedState = "_r9-3";
export var dragHandle = "_r9-5";
export var dragHandleIcon = "_r9-6";
export var dragging = "_r9-1";
export var titleArea = "_r9-4";